module.exports = __webpack_public_path__ + "assets/img/pexels-photo-1752806.b93a1619.png";